import '../common.js';
import '../../css/product_info.css';
import '../../jscript/jquery.elevatezoom.js';
require ('./jscript_countdown.min.js');
require ('./jscript_sharegg.js');
require ('./jscript_textarea_counter.js');
require ('./jscript_thumbelina.js');
require ('./jscript_product.js');

